/*
  WOODAMORE — reveal-on-scroll
  woodamore.css hides `.reveal { opacity: 0 }` and only shows it once the `.in`
  class is present. Dawn's animations.js only handles `.scroll-trigger`, so
  nothing was ever adding `.in` -> all `.reveal` content stayed invisible.
  This adds `.in` via IntersectionObserver, with safe fallbacks:
    - Shopify theme editor (design mode): reveal immediately.
    - No IntersectionObserver support: reveal immediately.
*/
(function () {
  function revealAll(root) {
    (root || document).querySelectorAll('.reveal:not(.in)').forEach(function (el) {
      el.classList.add('in');
    });
  }

  function init() {
    var els = document.querySelectorAll('.reveal:not(.in)');
    if (!els.length) return;

    var designMode = window.Shopify && window.Shopify.designMode;
    if (designMode || !('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    var io = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
    );

    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-reveal sections re-rendered inside the theme editor.
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { revealAll(e.target); });
  }
})();
